// TODO: merge this with the other helper file once all converted to TS
import type BehaviorCollection from 'web-app/behaviors/behaviors-collection';
import ObservationBehaviors from 'web-app/behaviors/observation-behavior-ids';

export const collectFrameworkIDsFromObservationBehaviors = (behaviors: BehaviorCollection): string[] | undefined => {
    const behavior = behaviors.behaviorForId(ObservationBehaviors.CanLinkToFrameworks);
    if (behavior) {
        return behavior.payload.frameworks.map(f => f.id);
    }
    return undefined;
};
